import { render, staticRenderFns } from "./studentRecordDetail.vue?vue&type=template&id=fa7da404&scoped=true"
import script from "./studentRecordDetail.vue?vue&type=script&lang=js"
export * from "./studentRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./studentRecordDetail.vue?vue&type=style&index=0&id=fa7da404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7da404",
  null
  
)

export default component.exports